/**
 * MCP 利用状況の Query Hook
 */

import { useQuery } from '@tanstack/react-query';
import { useAuthHeader } from '@/hooks/useAuth';
import { getMcpUsageAuthenticated, type McpUsageParams } from '@/lib/api/ai/mcpUsage';
import { mcpUsageKeys } from '../keys';
import { CACHE_TIME } from '../client';

/**
 * MCP 利用状況を取得する Query Hook
 */
export function useMcpUsage(params: McpUsageParams) {
  const { getAuthHeader, isLoading: authHeaderLoading, isAuthorized } = useAuthHeader();

  return useQuery({
    queryKey: mcpUsageKeys.data(
      params.start_date,
      params.end_date,
      params.caller_type ?? '',
      params.company_id ?? '',
      params.account_code ?? '',
      params.principal ?? '',
      params.granularity ?? '',
    ),
    queryFn: async () => {
      const authHeaders = getAuthHeader();
      return getMcpUsageAuthenticated(authHeaders, params);
    },
    enabled: !authHeaderLoading && isAuthorized && !!params.start_date && !!params.end_date,
    staleTime: CACHE_TIME.ACCOUNTS_LIST,
  });
}
